<template>
  <div id="SectionSBTiPricing">
    <UIContainer class="SectionSBTiPricing__container">
      <div class="SectionSBTiPricing__content">
        <SectionTitle>
          <template #heading>Investment based on Company size</template>
          <template #title>Choose your validation journey</template>
          <template #description>
            Unsure where to begin? Book a free 20-minute strategy call to assess
            your SBTi readiness.
          </template>
        </SectionTitle>

        <UIButton s1ize="xl" theme="primary" :to="{ name: 'Contact' }">
          Book a call
        </UIButton>
      </div>

      <div class="SectionSBTiPricing__plans">
        <PricingPlan v-for="plan in plans" :key="plan.title" v-bind="plan" />
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import PricingPlan, { IPlan } from '@/views/components/misc/PricingPlan.vue'
import UIButton from '@/views/components/ui/buttons/UIButton.vue'

const plans: IPlan[] = [
  {
    title: 'SBTi validation for SMEs',
    // price: '€7,500',
    features: [
      'Scope 1 & 2 target setting',
      'Employee engagement',
      'Grouped Kick-Off',
      'Dedicated expert',
    ],
    ctaText: 'Start assessment',
    ctaTheme: 'primary',
    ctaStyle: 'filled',
  },
  {
    title: 'Corporate SBTi advisory',
    // price: 'From €10,590',
    features: [
      'Scope 1 & 2 Physical',
      'Full Scope 3 Physical analysis',
      'Reduction actions',
      'Employee engagement',
      'Supplier engagement',
      'Grouped Kick-Off',
      'Dedicated expert & workshop',
      'Report presentation',
    ],
    ctaText: 'Get a quote',
    ctaTheme: 'primary',
    ctaStyle: 'filled',
  },
]
</script>

<style lang="scss" scoped>
#SectionSBTiPricing {
  .SectionSBTiPricing__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;

    @include md {
      gap: 4rem;
      grid-template-columns: 440px 1fr;
    }
  }

  .SectionSBTiPricing__content {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @include md {
      gap: 1.25rem;
    }
  }

  .SectionSBTiPricing__plans {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @include md {
      gap: 2rem;
      flex-direction: row;
    }
  }
}
</style>
